import React, { useState, useEffect } from 'react';

import { Button } from "components";

import { func_validation } from 'functions';

import ic_small_close_inverse from "assets/images/ic_small_close_inverse.svg";
import ic_small_close from "assets/images/ic_small_close.svg";

import "assets/scss/components/modals/generalModal.scss";



export function GeneralModal(props = {}) {
    const { 
        modalWapperClassName,
        headerClassName,
        title,
        bodyHeader, bodyHeaderClassName, 
        headerTitleClassName, headerCloseClassName,
        isCloseIconInverse, isCloseIconHidden,
        bodyClassName, bodyWrapperClassName,
        content, contentClassName,
        bodyFooter, bodyFooterClassName,
        footerClassName, footerAdditionalContent, footerAdditionalContentClassName,
        cancelButtonText, cancelButtonProps,
        confirmButtonText, confirmButtonProps,
        isModalVisible: isModalVisible_props,
        isBackgroundModalToggleDisabled,

        footerCancelWrapperClassName, footerConfirmWrapperClassName,
        footerCancelClassName, footerConfirmClassName,
        isConfirmSuccessful,
        
        isCancelButtonVisible,
        isConfirmButtonVisible, isToggleBeforeSubmissionNotRequired
    } = props;

    // Validate Props
    let cancelButtonText_validated = func_validation.isStringTrimNotEmpty(cancelButtonText)? cancelButtonText: "";
    let cancelButtonProps_validated = func_validation.isObjectNotEmpty(cancelButtonProps)? cancelButtonProps: {};
    let confirmButtonText_validated = func_validation.isStringTrimNotEmpty(confirmButtonText)? confirmButtonText: "";
    let confirmButtonProps_validated = func_validation.isObjectNotEmpty(confirmButtonProps)? confirmButtonProps: {};

    // Statess
    const [modalUniqueId] = useState(func_validation.getStringUniqueId("component-generalModal"));
    const [isModalVisible, setIsModalVisible] = useState(false);

    function attachModal() {
        let modal = document.getElementById(modalUniqueId);

        if (modal != null)
            document.body.appendChild(modal);
    }
    function removeModal() {
        let modal = document.getElementById(modalUniqueId);

        if (modal != null) {
            document.body.removeChild(modal);
            document.body.style.overflow = "initial";
        }
    }
    useEffect(() => {
        attachModal();
        return () => { removeModal(); }
    }, []);

    function toggleModalVisibility(isVisible, isConfirm) {
        if (isVisible) {
            document.body.style.overflow = "hidden";
            setIsModalVisible(true);
        }
        else {
            document.body.style.overflow = "initial";
            setIsModalVisible(false);
        }

        if (props.updateParentState &&
            (isVisible != isModalVisible))
            props.updateParentState(isVisible, isConfirm);
    }

    function handleOnCancel() {
        toggleModalVisibility(false);

        if (props.handleOnCancel) {
            props.handleOnCancel();
        }
    }
    function handleOnConfirm() {
        if (props.handleOnConfirm) {
            props.handleOnConfirm();
        }
    }

    useEffect(() => {
        if (isConfirmSuccessful)
            toggleModalVisibility(false, true);
    }, [isConfirmSuccessful]);

    useEffect(() =>{
        toggleModalVisibility(isModalVisible_props);
    }, [isModalVisible_props]);

    let closeIcon = isCloseIconInverse? ic_small_close_inverse: ic_small_close;
    
    return (
        <div id={modalUniqueId}
            className={"component-generalModal " +
                (isModalVisible? "d-flex align-items-center justify-content-center ": "d-none ")}
        >
            {/* Background */}
            <div className={"component-generalModal__bg"}
                onClick={() => { if (!isBackgroundModalToggleDisabled) toggleModalVisibility(false); }}
            />

            <div className={"component-generalModalWrapper d-flex flex-column justify-content-between " + 
                    (modalWapperClassName? modalWapperClassName + " ":"")}
            >
                {/* Header */}
                <div className={"component-generalModal-header d-flex align-items-center justify-content-between " +
                            (headerClassName? headerClassName + " ":"")}>
                    {/* Title */}
                    {func_validation.isStringTrimNotEmpty(title)? (
                        <div className={"component-generalModal-header-title " + 
                                    (headerTitleClassName? headerTitleClassName + " ":"")}>
                            {title}
                        </div>
                    ):""}

                    {/* Close */}
                    {isCloseIconHidden? "":(
                        <div className={"component-generalModal-header-close " +
                                (headerCloseClassName? headerCloseClassName + " ":"")}>
                        <img
                            src={closeIcon}
                            onClick={() => { toggleModalVisibility(false);}}
                        />
                    </div>
                    )}
                </div>

                {/* Body */}
                <div className={"component-generalModal-body flex-fill " +
                            (bodyClassName? bodyClassName + " ":"")}>

                    <div className={"component-generalModal-bodyWrapper " +
                                (bodyWrapperClassName? bodyWrapperClassName + " ":"")}>
                        {/* Header */}
                        {func_validation.isNotNullUndefined(bodyHeader)? (
                            <div className={"component-generalModal-body-header " +
                                    (bodyHeaderClassName? bodyHeaderClassName + " ":"")} >
                                {bodyHeader}
                            </div>
                        ):""}

                        {/* Content */}
                        {func_validation.isNotNullUndefined(content)? (
                            <div className={"component-generalModal-body-content " +
                                        (contentClassName? contentClassName + " ":"")}>
                                {content}
                            </div>
                        ):""}

                        {/* Footer */}
                        {func_validation.isNotNullUndefined(bodyFooter)? (
                            <div className={"component-generalModal-body-footer " +
                                        (bodyFooterClassName? bodyFooterClassName + " ":"")}>
                                {bodyFooter}
                            </div>
                        ):""}
                    </div>
                </div>

                {/* Footer */}
                <div className={"component-generalModal-footer d-flex align-items-center justify-content-center " +
                            (footerClassName? footerClassName + " ":"")}>
                                
                    {/* Additional content */}
                    {func_validation.isNotNullUndefined(footerAdditionalContent)? (
                        <div className={"component-generalModal-footer-contentWrapper " +
                                    (footerAdditionalContentClassName? footerAdditionalContentClassName + " ":"")}>
                            {footerAdditionalContent}
                        </div>
                    ):""}

                    {/* Cancel */}
                    {isCancelButtonVisible? (
                        <div className={"component-generalModal-footer-cancelButtonWrapper " +
                                (footerCancelWrapperClassName? footerCancelWrapperClassName + " ":"")}>
                            <Button
                                className={"component-generalModal-footer-cancelButton " +
                                    (footerCancelClassName? footerCancelClassName + " ":"")}
                                handleOnClick={handleOnCancel}
                                {...cancelButtonProps_validated}
                            >
                                {cancelButtonText_validated}
                            </Button>
                        </div>
                    ):""}

                    {/* Confirm */}
                    {isConfirmButtonVisible? (
                        <div className={"component-generalModal-footer-confirmButtonWrapper " +
                                    (footerConfirmWrapperClassName? footerConfirmWrapperClassName + " ":"")}>
                            <Button
                                className={"component-generalModal-footer-confirmButton " +
                                    (footerConfirmClassName? footerConfirmClassName + " ":"")}
                                handleOnClick={handleOnConfirm}
                                {...confirmButtonProps_validated}
                            >
                                {confirmButtonText_validated}
                            </Button>
                        </div>
                    ):""}
                </div>
            </div>
        </div>
    )
}